import { AsmCollaborationViewId } from '../models/asm-collaboration-view-id';
import { AsmCollaborationType } from '../models/asm-collaboration-type';
import { AsmOwaspTools } from '../tools/asm-owasp.tools';
import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';

export function provideAsmCollaborationViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmCollaborationType.annotation);
  typeService.addType(AsmCollaborationType.attachment);
  typeService.addType(AsmCollaborationType.owaspClassification);
  typeService.addType(AsmCollaborationType.owaspCode);
  typeService.addType(AsmCollaborationType.owaspVersion);
  viewService.addView(
    AsmCollaborationType.annotation.array,
    'read',
    AsmCollaborationViewId.notes,
    () =>
      import('../components/view/asm-view-read-notes/asm-view-read-notes.component').then(
        m => m.AsmViewReadNotesComponent,
      ),
    true,
  );
  viewService.addView(
    AsmCollaborationType.owaspClassification.array,
    'read',
    AsmCollaborationViewId.owaspTopTen,
    () =>
      import('../components/view/asm-view-read-owasp-top-ten/asm-view-read-owasp-top-ten.component').then(
        m => m.AsmViewReadOwaspTopTenComponent,
      ),
    true,
  );
  viewService.addView(
    AsmCollaborationType.attachment.array,
    'read',
    AsmCollaborationViewId.attachmentCompact,
    () =>
      import('../components/view/asm-view-read-attachment-compact/asm-view-read-attachment-compact.component').then(
        m => m.AsmViewReadAttachmentCompactComponent,
      ),
    true,
  );
  viewService.addView(
    AsmCollaborationType.attachment.array,
    'read',
    AsmCollaborationViewId.attachments,
    () =>
      import('../components/view/asm-view-read-attachments/asm-view-read-attachments.component').then(
        m => m.AsmViewReadAttachmentsComponent,
      ),
    false,
  );

  viewService.addView(
    AsmCollaborationType.owaspVersion,
    'edit',
    AsmCollaborationViewId.owaspVersionEdit,
    () =>
      import('../components/view/asm-view-edit-owasp-version/asm-view-edit-owasp-version.component').then(
        m => m.AsmViewEditOwaspVersionComponent,
      ),
    true,
  );
  viewService.addView(
    AsmCollaborationType.owaspVersion.array,
    'edit',
    AsmCollaborationViewId.owaspVersionEdit,
    () =>
      import('../components/view/asm-view-edit-owasp-version/asm-view-edit-owasp-version.component').then(
        m => m.AsmViewEditOwaspVersionComponent,
      ),
    true,
  );
  viewService.deriveView(
    AsmCollaborationType.owaspClassification.array,
    'read',
    AsmCollaborationType.owaspCode.array,
    AsmCollaborationViewId.owaspTopTen,
    { isDefault: true, mapValue: (codes: string[]) => AsmOwaspTools.fromCodes(codes) },
  );
  viewService.deriveView(SolType.tag.array, 'read', AsmCollaborationType.owaspCode, SolViewId.tag, {
    isDefault: true,
    mapValue: (value: string) => [AsmOwaspTools.toValueTag(value)],
  });
  viewService.deriveView(SolType.tag.array, 'read', AsmCollaborationType.owaspVersion, SolViewId.tag, {
    isDefault: true,
    mapValue: (edition: string) => [AsmOwaspTools.toValueTag(edition)],
  });
}
